import { useEffect, useState } from "react"
import _get from "lodash/get"
import DatePicker from "react-datepicker"
import calenderIcon from "@/public/icons/calendar.svg"
import Button from "@/components/core/Button/Button"
import Input from "@/components/core/Input/Input"
import Checkbox from "@/components/core/Checkbox/Checkbox"
import styles from "./index.module.scss"
import {
  validNumber,
  validText,
  validateOptionalEmail,
  validPincode,
  validateNoOfBathroom,
  validateNoOfBathroom_mandatroy,
  validateNoOfBathroom_optional,
} from "@/utils/validate"
import { validateField } from "@/utils/helper"
import { bookingExistMessage, PHONE_REGEX, slotBookedMessage } from "@/constants/index"
import { cleverTapSubscribe, getKECAppointments, leadCreation, registerUser } from "@/utils/enquiry"
import { useDispatch } from "react-redux"
import SelectDropdown from "@/components/core/SelectDropdown/SelectDropdown"
import useOmniChannel from "@/i18n/useOmniChanneli18n"
import Modal from "@/components/core/Modal/Modal"
import ConfirmationModal from "../checkout/ConfimationModal/ConfirmationModal"
import { hideLeadForm } from "@/store/features/cartSlice"
import PageLoader from "@/components/core/PageLoader/PageLoader"
import {
  getEventInfoFormSubmit,
  getFormInfoForSubmittion,
  getSuccessMessageByPageType,
  getParamsByURL,
  kecCityMapping,
  getSuccessMessageByPageTypeService,
  getInitialDataValues,
  addSessionUserDetails,
  verifyRecaptchaToken,
  recaptchaSiteKey,
  recaptchaError,
  getEventInfoFormFilled,
  getEventInfoRecaptcha
} from "@/components/OmniChannel/common-methods"
import ImageUpload from "../RegisterOfflineProduct/v1/ImageUpload"
import { getDetailsFromZipCode } from "@/utils/findStore"
import moment from "moment"
import DateTimePicker from "@/components/OmniChannel/DateTimePicker"
import { changeSlotAnalytics, slotAlreadyBookedAnalytics } from "@/components/OmniChannel/analytics"
import ReCAPTCHA from "react-google-recaptcha"
const RecaptchaForm = props => {
  const { authorData, omniQRParams, isQrService, isKohlerCare=false } = props
  const staticText = useOmniChannel(authorData)
  const {
    budgetItems,
    purchaseTimeItems,
    citiesAvailableItems,
    productCategoryItems,
    typeItems,
  } = authorData
  const [error, setError] = useState({})
  const [data, setData] = useState({})
  const [recaptchaVerified, setRecaptchaVerified] = useState(false)
  const [modalDisplayFlag, setModalDisplayFlag] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [paramsByUrl, setParamsByUrl] = useState({})
  const [showErrorModal, setShowErrorModal] = useState(false)
  const dispatch = useDispatch()
  const [stateCityDisabled, setStateCityDisabled] = useState(true)
  const [clearImage, setClearImage] = useState(false)
  const [uploadImageLoading, setUploadImageLoading] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [monthlyAvailabilityData, setMonthlyAvailabilityData] = useState({})
  const [kecSlotBooked, setKecSlotBooked] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [numberOfReTries, setNumberOfReTries] = useState(0)
  const [token, setToken] = useState(null)
  const numberOfTriesAllowed=2
  useEffect(() => {
    const _url_params = getParamsByURL(omniQRParams)
    setParamsByUrl(_url_params)
    const dataInitialValue = getInitialDataValues(_url_params)
    setData(dataInitialValue)
  }, [])

  const handleTextFieldChange = e => {
    const { name, value } = e.target
    if (value === "" || validText(value)) {
      setData({
        ...data,
        [name]: value,
      })
      setError({ ...error, [name]: "" })
    }
  }
  const handleAlphaNumericFieldChange = e => {
    const { name, value } = e.target
    setData({
      ...data,
      [name]: value,
    })
    setError({ ...error, [name]: "" })
  }

  const changeDateFormat = date => {
    if (date) {
      const dateVal = moment(date).format("YYYY-MM-DD")
      setData({ ...data, dateOfInvoice: dateVal })
      setError({})
    } else {
      setData({ ...data, dateOfInvoice: "" })
    }
  }

  const handleNumberFieldChange = e => {
    const { name, value } = e.target
    if (value === "" || validNumber(value)) {
      setData({
        ...data,
        [name]: value,
      })
      setError({
        ...error,
        [name]: "",
      })
    }
  }

  const getAppointments = async (kecCity)=>{
     const response = await getKECAppointments({
        city: kecCityMapping?.find(item => item[kecCity])[kecCity],
      })
      const {monthlyAvailability} = response
      setMonthlyAvailabilityData(monthlyAvailability)
  }

  const handleDropDownChange = (value, field) => {
    
    if(field==="kecCity"){
      getAppointments(value)
      setData({...data, slot:"", appointmentDate:"",  [field]: value,})
      setError({
        ...error,
        [field]: "",
      })
    }
    else{
      setData({
      ...data,
      [field]: value,
      })
      setError({
        ...error,
        [field]: "",
      })
    }
  }
  useEffect(() => {
    if (
      authorData.warrantyRegistrationFormFlag ||
      authorData.siteRegistrationFormFlag || authorData.serviceRequestFormFlag || authorData.omniChannelKECFormFlag
    ) {
      if (data?.pinCode && validPincode(data?.pinCode)) {
        const response = getDetailsFromZipCode(data?.pinCode)
        response.then(resp => {
          const { statusCode, result = {} } = resp

          if (statusCode === 200) {
            const { city, state } = result?.data ?? {}
            setData({
              ...data,
              city: city,
              state: state,
            })
            setStateCityDisabled(true)
            if(authorData.omniChannelKECFormFlag ){
              if(citiesAvailableItems.findIndex(ele=>ele.citiesAvailable.toLowerCase()===city.toLowerCase())>=0){
                setData({
                  ...data,
                  kecCity: city,
                })
                getAppointments(city)
                setError({
                  ...error,
                  kecCity: "",
                })
              }
            }
          } else {
            setError({
              ...error,
              pinCode: staticText.wrongPincodeError,
            })
            setStateCityDisabled(true)
          }
        })
      } else if (data?.pinCode) {
        setData({
          ...data,
          city: "",
          state: "",
        })
        if(authorData.omniChannelKECFormFlag ){
          setData({
          ...data,
          kecCity: "",
           slot:"",
          appointmentDate:""
        })
        setMonthlyAvailabilityData({})
        }
      }
    }
  }, [data?.pinCode])

  const onChangeEmail = e => {
    const { value } = e.target
    setData({
      ...data,
      email: value,
    })
    if (value) {
      if (validateOptionalEmail(value)) {
        setError({
          ...error,
          email: null,
        })
      } else {
        setError({
          ...error,
          email: staticText.emailAddressError,
        })
      }
    }
  }

  const handleConsent = (e, fieldname) => {
    setData({
      ...data,
      [fieldname]: e.target.checked,
    })
  }

  const modalCloseHandler = () => {
    setModalDisplayFlag(false)
    const form_session_val = getInitialDataValues(paramsByUrl)
    setData(form_session_val)
    if (
      authorData.bathroomInspirationFormFlag ||
      authorData.selfRegistrationFormFlag
    )
      dispatch(hideLeadForm())
    if (authorData.bathroomInspirationFormFlag)
      window.open(authorData.pdfPath, "_blank")
    setTimeout(function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }, 5)
  }

  const closeErrorModal = () => {
    setShowErrorModal(false)
    const form_session_val = getInitialDataValues(paramsByUrl)

    if(!kecSlotBooked){
        setData(form_session_val)
    }
    else{
      setData({...data, slot:"", appointmentDate:""})
      getAppointments(data.kecCity)
      handleModalClose()
    }
    setKecSlotBooked(false)
    if (
      authorData.bathroomInspirationFormFlag ||
      authorData.selfRegistrationFormFlag
    )
      dispatch(hideLeadForm())
  }

  const getNoOfBathroomLabel = () =>
    authorData.omniChannelKECFormFlag || authorData.amcFormFlag
      ? `${staticText?.noOfBathroomLabel}*`
      : `${staticText?.noOfBathroomLabel}`

  const isValidNumber =
    PHONE_REGEX.test(data?.mobileNumber) && data?.firstName && data?.lastName

  const onBlur = field => {
    setError({
      ...error,
      [field]: validateFormValues(field),
    })
  }

  const validateFormValues = field => {
    if (field === "firstName" || field === "lastName") {
      if (!data[field]?.trim() || !validateField("name", data[field])) {
        switch (field) {
          case "firstName":
            return staticText?.firstNameError
          case "lastName":
            return staticText?.lastNameError
          default:
            return ""
        }
      }
    } else if (field === "email") {
      if (!validateOptionalEmail(data[field])) {
        return staticText?.emailAddressError
      } else {
        return ""
      }
    } else if (field === "pinCode") {
      if (!data[field]) {
        return staticText?.noPinCodeError
      } else if (!validPincode(data[field])) {
        return staticText?.inValidPinCodeError
      } else if (
        authorData.siteRegistrationFormFlag ||
        authorData.warrantyRegistrationFormFlag
      ) {
        return error.pinCode
      }
    } else if (field === "noOfBathroom") {
      if (authorData.omniChannelKECFormFlag || authorData.amcFormFlag) {
        if (!validateNoOfBathroom_mandatroy(data[field])) {
          return staticText?.bathroomNoEmpty
        }
      } else {
        if (!validateNoOfBathroom_optional(data[field])) {
          return staticText?.bathroomNoEmpty
        }
      }
    } else if (field === "mobileNumber") {
      if (!data[field]?.trim()) {
        return staticText?.mobileNumberError
      } else if (!PHONE_REGEX.test(data[field])) {
        return staticText?.validMobileNoError
      }
    } else if (field === "productCategory") {
      if (!data[field]) {
        return !authorData.serviceRequestFormFlag ? staticText?.productCategoryError : staticText.productDetailsError
      }
    } else if (field === "purchasePick") {
      if (!data[field]) {
        return staticText?.purchasePickError
      }
    } else if (field === "kecCity") {
      if (!data[field]) {
        return staticText?.kecCityError
      }
    } else if (field === "productImages") {
      if (data[field] && !data[field].length) {
        return staticText?.provideImageError
      }
    } else if (field === "state") {
      if (!data[field]) {
        return staticText?.stateError
      }
    } else if (field === "city") {
      if (!data[field]) {
        return staticText?.cityError
      }
    } else if (field === "siteAddress") {
      if (!data[field]) {
        return staticText?.siteAddressError
      }
    } else if (field === "constructionType") {
      if (!data[field]) {
        return staticText?.constructionTypeError
      }
    } else if (field === "fileType") {
      if (!data[field]) {
        return staticText?.fileTypeError
      }
    } else if (field === "reportIssue") {
      if (!data[field]) {
        return staticText?.reportIssueError
      }
    } else if (field === "alternateMobileNumber") {
      if (data[field] && !PHONE_REGEX.test(data[field])) {
        return staticText?.validMobileNoError
      }
    }
    else if (field === "slot") {
      if (!data[field]) {
        return staticText?.slotError
      }
    }
  }

  const getErrorList = () => {
    let errorList
    errorList = {
      firstName: validateFormValues("firstName"),
      lastName: validateFormValues("lastName"),
      pinCode: validateFormValues("pinCode"),
      mobileNumber: validateFormValues("mobileNumber"),
    }
    if (authorData.omniChannelKECFormFlag) {
      errorList = {
        ...errorList,
        kecCity: validateFormValues("kecCity"),
        purchasePick: validateFormValues("purchasePick"),
        noOfBathroom: validateFormValues("noOfBathroom"),
        slot: validateFormValues("slot"),
      }
    } else if (authorData.warrantyRegistrationFormFlag) {
      errorList = {
        ...errorList,
        state: validateFormValues("state"),
        city: validateFormValues("city"),
        siteAddress: validateFormValues("siteAddress"),
      }
    } else if (authorData.siteRegistrationFormFlag) {
      errorList = {
        ...errorList,
        productCategory: validateFormValues("productCategory"),
        constructionType: validateFormValues("constructionType"),
        state: validateFormValues("state"),
        city: validateFormValues("city"),
        siteAddress: validateFormValues("siteAddress"),
      }
    } else if (authorData.serviceRequestFormFlag) {
      errorList = {
        ...errorList,
        state: validateFormValues("state"),
        city: validateFormValues("city"),
        siteAddress: validateFormValues("siteAddress"),
        productCategory: validateFormValues("productCategory"),
        reportIssue: validateFormValues("reportIssue"),
      }
    } else if (authorData.amcFormFlag){
       errorList = {
        ...errorList,
        siteAddress: validateFormValues("siteAddress"),
         noOfBathroom: validateFormValues("noOfBathroom"),
      }
    }
    return errorList
  }
 

  const isSubmitBtnEnabled =
    Object?.values(getErrorList())?.find(el => el) || !recaptchaVerified
      ? true
      : false

  const isAllFieldsFilled =
    Object?.values(getErrorList())?.find(el => el)
      ? false
      : true

  useEffect(()=>{
    if(isAllFieldsFilled){
      pushFormFilledAnalytics()
    }
  },[isAllFieldsFilled])

  const handleError = (tries)=>{
    if(tries<numberOfTriesAllowed){
      setNumberOfReTries(tries)
    }
    else{
      e.preventDefault()
      window.location.href = window.location.origin + recaptchaError
    }
  }

  const pushFormSubmitAnalytics = resultType => {
    const { adobeDataLayer: { getState } = {} } = window
    const page = getState?.("page") || {}
    const eventInfo = getEventInfoFormSubmit(authorData, resultType)
    const formInfo = getFormInfoForSubmittion(data, authorData, paramsByUrl)
    window.adobeDataLayer.push({
      event: "cmp:click",
      eventInfo,
      page,
      ...formInfo,
    })
  }

  const pushFormFilledAnalytics = () =>{
    const { adobeDataLayer: { getState } = {} } = window
    const page = getState?.("page") || {}
    const eventInfo = getEventInfoFormFilled()
    const formInfo = getFormInfoForSubmittion(data, authorData, paramsByUrl)
    window.adobeDataLayer.push({
      event: "cmp:click",
      eventInfo,
      page,
      ...formInfo,
    })
  }

  const recaptchaAnalytics = (isSuccess)=>{
    const { adobeDataLayer: { getState } = {} } = window
    const page = getState?.("page") || {}
    const eventInfo = getEventInfoRecaptcha(isSuccess)
    const formInfo = getFormInfoForSubmittion(data, authorData, paramsByUrl)
    window.adobeDataLayer.push({
      event: "cmp:click",
      eventInfo,
      page,
      ...formInfo,
    })
  }

  const getPayload = data => {
    let payloadJson
    const {
      firstName,
      lastName,
      mobileNumber,
      email,
      pinCode,
      city,
      state,
      siteAddress,
      constructionType,
      kecCity,
      noOfBathroom,
      budget,
      purchasePick,
      productCategory,
      whatsAppConsent,
      smsAppConsent,
      productImages,
      fileType,
      dateOfInvoice,
      reportIssue,
      alternateMobileNumber,
      landmark,
      slot,
      appointmentDate
    } = data
    if (
      authorData.selfRegistrationFormFlag ||
      authorData.bathroomInspirationFormFlag
    ) {
      payloadJson = {
        leadInfo: {
          firstName: firstName,
          lastName: lastName,
          phone: mobileNumber,
          ...(email !== "" && { email }),
          pincode: pinCode,
          scanEventType: authorData.selfRegistrationFormFlag
            ? "Self Lead"
            : "Bathroom Inspiration",
          whatsappOptIn: whatsAppConsent,
          otherOptIn: smsAppConsent,
          ...(noOfBathroom !== "" && { numberOfBathrooms: noOfBathroom }),
          ...(budget !== "" && { budget: budget }),
          leadSubSourceSegment: paramsByUrl["leadSubSourceSegment"],
          qrId: paramsByUrl["qrId"],
          campaignId: paramsByUrl["campaignId"]!==""?paramsByUrl["campaignId"]:null,
          kecId: paramsByUrl["kecId"]!==""?paramsByUrl["kecId"]:null,
          eventId: paramsByUrl["eventId"]!==""?paramsByUrl["eventId"]:null,
          dealerId: paramsByUrl["leadSubSourceSegment"] === "Dealer" ? paramsByUrl["dealerId"] : paramsByUrl["kaspId"],
          technicianId: paramsByUrl["technicianId"]!==""?paramsByUrl["technicianId"]:null
        },
      }
    } else if (authorData.omniChannelKECFormFlag) {
      payloadJson = {
        leadInfo: {
          firstName: firstName,
          lastName: lastName,
          phone: mobileNumber,
          email: email,
          pincode: pinCode,
          scanEventType: "KEC Appointment",
          whatsappOptIn: whatsAppConsent,
          otherOptIn: smsAppConsent,
          numberOfBathrooms: noOfBathroom,
          budget: budget,
          KECCity: kecCityMapping?.find(item => item[kecCity])[kecCity],
          projectTimeline: purchasePick,
          leadSubSourceSegment: paramsByUrl["leadSubSourceSegment"],
          qrId: paramsByUrl["qrId"],
          campaignId: paramsByUrl["campaignId"]!==""?paramsByUrl["campaignId"]:null,
          kecId: paramsByUrl["kecId"]!==""?paramsByUrl["kecId"]:null,
          eventId: paramsByUrl["eventId"]!==""?paramsByUrl["eventId"]:null,
          dealerId: paramsByUrl["leadSubSourceSegment"] === "Dealer" ? paramsByUrl["dealerId"] : paramsByUrl["kaspId"],
          technicianId: paramsByUrl["technicianId"]!==""?paramsByUrl["technicianId"]:null
        },
        ...(slot!=="" && appointmentDate!=="" && {appointmentInfo:{
          slot : slot,
          appointmentDate: appointmentDate
        }})
      }
    } else if (authorData.warrantyRegistrationFormFlag) {
      payloadJson = {
        warrantyInfo: {
          firstName: firstName,
          lastName: lastName,
          phone: mobileNumber,
          pincode: pinCode,
          scanEventType: "Warranty Registration",
          whatsappOptIn: whatsAppConsent,
          otherOptIn: smsAppConsent,
          siteAddress: siteAddress,
          state: state,
          city: city,
          uploadFileType: fileType,
          ...(productImages && { invoiceUrl: productImages[0] }),
          qrId: paramsByUrl["qrId"],
          campaignId: paramsByUrl["campaignId"]!==""?paramsByUrl["campaignId"]:null,
          kecId: paramsByUrl["kecId"]!==""?paramsByUrl["kecId"]:null,
          eventId: paramsByUrl["eventId"]!==""?paramsByUrl["eventId"]:null,
          dealerId: paramsByUrl["leadSubSourceSegment"] === "Dealer" ? paramsByUrl["dealerId"] : paramsByUrl["kaspId"],
          technicianId: paramsByUrl["technicianId"]!==""?paramsByUrl["technicianId"]:null,
          source: `QR-${paramsByUrl["leadSubSourceSegment"]}`,
        },
      }
    } else if (authorData.siteRegistrationFormFlag) {
      payloadJson = {
        leadInfo: {
          firstName: firstName,
          lastName: lastName,
          phone: mobileNumber,
          pincode: pinCode,
          scanEventType: "Site Visit",
          whatsappOptIn: whatsAppConsent,
          otherOptIn: smsAppConsent,
          siteAddress: siteAddress,
          state: state,
          KECCity: city,
          segment: constructionType,
          ...(email !== "" && { email }),
          ...(noOfBathroom !== "" && { numberOfBathrooms: noOfBathroom }),
          ...(budget !== "" && { budget: budget }),
          leadSubSourceSegment: paramsByUrl["leadSubSourceSegment"],
          qrId: paramsByUrl["qrId"],
          campaignId: paramsByUrl["campaignId"]!==""?paramsByUrl["campaignId"]:null,
          kecId: paramsByUrl["kecId"]!==""?paramsByUrl["kecId"]:null,
          eventId: paramsByUrl["eventId"]!==""?paramsByUrl["eventId"]:null,
          dealerId: paramsByUrl["leadSubSourceSegment"] === "Dealer" ? paramsByUrl["dealerId"] : paramsByUrl["kaspId"],
          technicianId: paramsByUrl["technicianId"]!==""?paramsByUrl["technicianId"]:null,
        },
        accountInfo: {
          defaultAddress: true,
        },
        caseInfo: {
          productBroadCategory: productCategory,
        },
      }
    } else if (authorData.amcFormFlag) {
      if(isKohlerCare){
        payloadJson={
          accountInfo: {
            firstName: firstName,
            lastName: lastName,
            phone: mobileNumber,
            pincode: pinCode,
            siteAddress: siteAddress,
            whatsappOptIn: whatsAppConsent,
            otherOptIn: smsAppConsent,
          }, 
          mainPlanInfo: {
              numberOfBathrooms : noOfBathroom, 
              ...(productImages && { invoiceUrl: productImages[0] }),
              ...(constructionType !== "" && { type: constructionType }),
          }
        }
      } else{
        payloadJson = {
          accountInfo: {
            firstName: firstName,
            lastName: lastName,
            phone: mobileNumber,
            pincode: pinCode,
            address: siteAddress,
            whatsappOptIn: whatsAppConsent,
            otherOptIn: smsAppConsent
          },
          mainplanInfo: {
            numberOfBathrooms: noOfBathroom,
            ...(constructionType !== "" && { type: constructionType }),
            qrId: `${paramsByUrl["qrId"]}`,
            source: `${paramsByUrl["leadSubSourceSegment"]}`,
            campaignId: paramsByUrl["campaignId"]!==""?paramsByUrl["campaignId"]:null,
            ...(productImages && { invoiceUrl: productImages[0] }),
          },
          caseInfo: {
            scanEventType: "AMC",
            kecId: paramsByUrl["kecId"]!==""?paramsByUrl["kecId"]:null,
            eventId: paramsByUrl["eventId"]!==""?paramsByUrl["eventId"]:null,
            dealerId: paramsByUrl["leadSubSourceSegment"] === "Dealer" ? paramsByUrl["dealerId"] : paramsByUrl["kaspId"],
            technicianId: paramsByUrl["technicianId"]!==""?paramsByUrl["technicianId"]:null,
            productBroadCategory: "Not Defined",
          }
        }
      }
    } else if (authorData.serviceRequestFormFlag) {
      payloadJson = {
        accountInfo: {
          firstName: firstName,
          lastName: lastName,
          phone: mobileNumber,
          ...(alternateMobileNumber !== "" && { alternatePhone: alternateMobileNumber }),
          ...(email !== "" && { email }),
          siteAddress: siteAddress,
          pincode: pinCode,
          city: city,
          state: state,
          whatsappOptIn: whatsAppConsent,
          otherOptIn: smsAppConsent,
          landmark: landmark,
          defaultAddress: true
        },
        caseInfo: {
          scanEventType: "Service Request",
          dateOfInvoice: dateOfInvoice,
          qrId: `${paramsByUrl["qrId"]}`,
          campaignId: paramsByUrl["campaignId"]!==""?paramsByUrl["campaignId"]:null,
          kecId: paramsByUrl["kecId"]!==""?paramsByUrl["kecId"]:null,
          eventId: paramsByUrl["eventId"]!==""?paramsByUrl["eventId"]:null,
          dealerId: paramsByUrl["leadSubSourceSegment"] === "Dealer" ? paramsByUrl["dealerId"] : paramsByUrl["kaspId"],
          technicianId: paramsByUrl["technicianId"]!==""?paramsByUrl["technicianId"]:null,
          reportIssue: reportIssue,
          productBroadCategory: productCategory,
          source: `${paramsByUrl["leadSubSourceSegment"]}`,
        }
      }
    }
    return payloadJson
  }
  const getCleverTapPayload = data => {
    const {
      firstName,
      lastName,
      mobileNumber,
      whatsAppConsent,
      smsAppConsent,
      email,
    } = data
    return {
      firstName: firstName,
      lastName: lastName,
      phoneNumber: `+91${mobileNumber}`,
      whatsAppOptIn: whatsAppConsent,
      ...(email !== "" && { emailId: email }),
      emailOptIn: smsAppConsent,
      smsOptIn: smsAppConsent,
    }
  }
  const handleSubmit = async () => {
    const errorList = getErrorList()
    let resultType = "failed"
    setIsLoading(true)
    let errorDataList = []
    setError(errorList)
    errorDataList.map((item, i) => {
      if (i === 0) document.getElementById(`${item}`)?.focus()
    })
    const isInvalid = Object?.values(errorList)?.find(el => el)
    if (!isInvalid) {
      const payload = getPayload(data)
      const cleverTapPayload = getCleverTapPayload(data)
      const response = await leadCreation({
        payload,
        authorData
      })
      await cleverTapSubscribe({ payload: cleverTapPayload })
      if (response.status === "success" || response.status === "Success") {
        const { qrId } = paramsByUrl;
        addSessionUserDetails(qrId,data)
        setModalDisplayFlag(true)
        setClearImage(true)
        resultType = "success"
      } else {
        setShowErrorModal(true)
        setClearImage(true)
        resultType = "failed"
        if(response.response.data.errorCode==="ER026" && authorData.omniChannelKECFormFlag){  
          const message = response.response.data.message          
          const match = message.match(/\d{4}-\d{2}-\d{2}/);
          let extractedDate = match[0];
          setErrorMessage(`An active appointment already exists for you on ${extractedDate}.`)  
          setKecSlotBooked(true)
          slotAlreadyBookedAnalytics(data)
        }
        else if((response.response.data.errorCode==="ER027"|| response.response.data.errorCode==="ER028") && authorData.omniChannelKECFormFlag){
          setKecSlotBooked(true)
          slotAlreadyBookedAnalytics(data)
          setErrorMessage("Sorry! this slot just got book by another user. Please select alternate slot.")
        }
      }
      setClearImage(true)
      setIsLoading(false)
    }
    pushFormSubmitAnalytics(resultType)
  }
  
  const handleModalClose = () => {
    const element = document.getElementById("omni-channel-form")
    if (element) {
      if(element.offsetTop>250)
      setTimeout(function () {
        window.scrollTo({ top: element.offsetTop - 250, behavior: "smooth" })
      }, 50)
      else
         setTimeout(function () {
        window.scrollTo({ top: element.offsetTop+2100, behavior: "smooth" })
      }, 50)
    }
  }
  const onChangeDateTime = (slot, date)=>{
    setData({
      ...data,
      slot: slot,
      appointmentDate: date
    })
  }
  const formatDate = (input)=>{
    const date = new Date(input);
    const options = { day: "numeric", month: "short", year: "numeric" };
    const formatted = date.toLocaleDateString("en-GB", options);
    return formatted
  }

  const onChangeHandler = (value)=>{
    setToken(value)
    const isSuccess=verifyRecaptchaToken(value)
    setRecaptchaVerified(isSuccess)    
    if(!isSuccess){
      handleError(numberOfReTries+1)
    }
    recaptchaAnalytics(isSuccess)
  }

  return (
    <>
      <PageLoader
        loading={uploadImageLoading}
        loadingMessage={
          uploadImageLoading ? "Upload In Progress..." : "Loading..."
        }
      />
      <div className={styles.OmniChannelFormWrapper}>
        <div className="omni-channel-form" id="omni-channel-form">
          <Input
            id="omni-channel-form_firstname"
            type="text"
            placeholder={`${staticText?.firstNameLabel}`}
            label={`${staticText?.firstNameLabel}*`}
            value={data?.firstName ?? ""}
            onChange={handleTextFieldChange}
            onInput={handleTextFieldChange}
            showError={error?.firstName}
            errorMessage={error?.firstName}
            onBlur={() => onBlur("firstName")}
            autoComplete={false}
            maxLength={40}
            name="firstName"
          />
          {authorData.warrantyRegistrationFormFlag ? (
            <div className="omni-channel-form__nameText">
              {staticText?.firstNameDescription}
            </div>
          ) : null}
          <Input
            id="omni-channel-form_lastname"
            type="text"
            placeholder={`${staticText?.lastNameLabel}*`}
            label={`${staticText?.lastNameLabel}*`}
            value={data?.lastName ?? ""}
            onChange={handleTextFieldChange}
            onInput={handleTextFieldChange}
            showError={error?.lastName}
            errorMessage={error?.lastName}
            onBlur={() => onBlur("lastName")}
            autoComplete={false}
            maxLength={40}
            name="lastName"
          />
          {authorData.warrantyRegistrationFormFlag ? (
            <div className="omni-channel-form__nameText">
              {staticText?.lastNameDescription}
            </div>
          ) : null}
          <div className="omni-channel-form__phoneDiv flex-mobile">
            <div className="omni-channel-form__countryIcon country-code">
              <Input
                customClass=""
                id="contact-user-country-code"
                type="text"
                disabled
                value={"+91"}
              />
            </div>

            <div className="omni-channel-form__mobileNumber mobile-number">
              <Input
                customClass="customer-support-inputfield"
                id="contact-user-mobile-number"
                type="text"
                value={data?.mobileNumber}
                maxLength={10}
                placeholder={`${staticText?.mobileNumberLabel}*`}
                label={`${staticText?.mobileNumberLabel}*`}
                onChange={handleNumberFieldChange}
                showError={error?.mobileNumber}
                errorMessage={error?.mobileNumber}
                onBlur={() => onBlur("mobileNumber")}
                name="mobileNumber"
              />
            </div>
          </div>

          {isQrService && authorData.serviceRequestFormFlag && (
            <Input
              customClass="customer-support-inputfield"
              id="contact-user-mobile-number"
              type="text"
              value={data?.alternateMobileNumber}
              maxLength={10}
              placeholder={`${staticText?.alternateMobileNumberLabel}`}
              label={`${staticText?.alternateMobileNumberLabel}`}
              onChange={handleNumberFieldChange}
              showError={error?.alternateMobileNumber}
              errorMessage={error?.alternateMobileNumber}
              onBlur={() => onBlur("alternateMobileNumber")}
              name="alternateMobileNumber"
            />
          )}
          {isQrService && authorData.serviceRequestFormFlag && (
            <Input
              customClass="customer-support-inputfield"
              id="contact-user-mobile-number"
              type="text"
              value={data?.siteAddress}
              maxLength={255}
              placeholder={`${staticText?.addressLabel}*`}
              label={`${staticText?.addressLabel}*`}
              onChange={handleAlphaNumericFieldChange}
              onInput={handleAlphaNumericFieldChange}
              showError={error?.siteAddress}
              errorMessage={error?.siteAddress}
              onBlur={() => onBlur("siteAddress")}
              name="siteAddress"
            />
          )}
          {isQrService && authorData.serviceRequestFormFlag && (
            <Input
              customClass="customer-support-inputfield"
              id="contact-user-mobile-number"
              type="text"
              value={data?.landmark}
              maxLength={80}
              placeholder={`${staticText?.landmarkLabel}`}
              label={`${staticText?.landmarkLabel}`}
              onChange={handleAlphaNumericFieldChange}
              onInput={handleAlphaNumericFieldChange}
              onBlur={() => onBlur("landmark")}
              name="landmark"
            />
          )}

          {!authorData.warrantyRegistrationFormFlag &&
            !authorData.amcFormFlag && (
              <Input
                id="contact-user-email"
                type="text"
                placeholder={`${staticText?.emailLabel}`}
                label={`${staticText?.emailLabel}`}
                prefix={
                  <img src={"/icons/email.svg"} alt="" aria-hidden="true" />
                }
                value={data?.email ?? ""}
                maxLength={60}
                autoComplete={true}
                onChange={onChangeEmail}
                onInput={onChangeEmail}
                showError={error?.email !== "" && error?.email}
                errorMessage={error?.email}
                onBlur={() => onBlur("email")}
                name={"email"}
              />
            )}
          <Input
            id="omni-channel-form_pinCode"
            type="text"
            placeholder={`${staticText?.pinCodeLabel}*`}
            label={`${staticText?.pinCodeLabel}*`}
            value={data?.pinCode ?? ""}
            onChange={handleNumberFieldChange}
            onInput={handleNumberFieldChange}
            showError={error?.pinCode}
            errorMessage={error?.pinCode}
            onBlur={() => onBlur("pinCode")}
            autoComplete={false}
            maxLength={6}
            name={"pinCode"}
          />

          {(authorData.siteRegistrationFormFlag ||
            authorData.warrantyRegistrationFormFlag ||
            (isQrService && authorData.serviceRequestFormFlag)) && (
            <div className="omni-channel-form__gap">
              <div className="omni-channel-form__state-city">
                <Input
                  id="omni-channel-form_city"
                  type="text"
                  placeholder={`${staticText?.cityLabel}*`}
                  label={`${staticText?.cityLabel}*`}
                  value={data?.city ?? ""}
                  onChange={handleTextFieldChange}
                  onInput={handleTextFieldChange}
                  autoComplete={false}
                  maxLength={30}
                  name={"city"}
                  disabled={stateCityDisabled}
                />
              </div>
              <div className="omni-channel-form__state-city">
                <Input
                  id="omni-channel-state"
                  type="text"
                  placeholder={`${staticText?.cityLabel}*`}
                  label={`${staticText?.stateLabel}*`}
                  value={data?.state}
                  onChange={handleTextFieldChange}
                  onInput={handleTextFieldChange}
                  autoComplete={false}
                  maxLength={30}
                  name={"state"}
                  disabled={stateCityDisabled}
                />
              </div>
            </div>
          )}
          {(authorData.siteRegistrationFormFlag ||
            authorData.warrantyRegistrationFormFlag ||
            authorData.amcFormFlag) && (
            <div>
              <Input
                id="omni-channel-form_SiteAddress"
                type="text"
                placeholder={`${staticText?.siteAddressLabel}*`}
                label={`${staticText?.siteAddressLabel}*`}
                value={data?.siteAddress ?? ""}
                onChange={handleAlphaNumericFieldChange}
                onInput={handleAlphaNumericFieldChange}
                autoComplete={false}
                maxLength={255}
                name={"siteAddress"}
                onBlur={() => onBlur("siteAddress")}
                showError={error?.siteAddress !== "" && error?.siteAddress}
                errorMessage={error?.siteAddress}
              />
            </div>
          )}
          {authorData.siteRegistrationFormFlag && (
            <div className="mb-20">
              <SelectDropdown
                data={typeItems?.map(item => item.type)}
                label={`${staticText?.constructionTypeLabel}*`}
                onChange={val => handleDropDownChange(val, "constructionType")}
                value={data?.constructionType}
                id="omni-channel-construction-type"
                name="constructionType"
              />
            </div>
          )}

          {authorData.omniChannelKECFormFlag && (
            <div className="mb-20">
              <SelectDropdown
                data={citiesAvailableItems.map(item => item.citiesAvailable)}
                label={`${staticText?.kecCityLabel}*`}
                onChange={val => handleDropDownChange(val, "kecCity")}
                value={data?.kecCity}
                id="omni-channel-kec"
                name="kecCity"
                errorMessage={staticText?.kecCityError}
                showError={
                  !error.kecCity || error.kecCity === "" ? false : true
                }
                onBlur={() => onBlur("kecCity")}
              />
            </div>
          )}
          {!authorData.warrantyRegistrationFormFlag &&
            !(isQrService && authorData.serviceRequestFormFlag) && (
              <Input
                id="omni-channel-form_noOfBathroom"
                type="text"
                placeholder={getNoOfBathroomLabel()}
                label={getNoOfBathroomLabel()}
                value={data?.noOfBathroom}
                onChange={handleNumberFieldChange}
                onInput={handleNumberFieldChange}
                autoComplete={false}
                maxLength={2}
                name={"noOfBathroom"}
                onBlur={() => onBlur("noOfBathroom")}
                errorMessage={error?.noOfBathroom}
                showError={
                  !error.noOfBathroom || error.noOfBathroom === ""
                    ? false
                    : true
                }
              />
            )}
          {!authorData.warrantyRegistrationFormFlag &&
            !(isQrService && authorData.serviceRequestFormFlag) &&
            !(isQrService && authorData.amcFormFlag) &&
            !isKohlerCare && (
              <div className="mb-20">
                <SelectDropdown
                  data={budgetItems?.map(item => item.budget)}
                  label={`${staticText?.budgetLabel}`}
                  onChange={val => handleDropDownChange(val, "budget")}
                  onBlur={() => onBlur("budget")}
                  value={data?.budget}
                  id="omni-channel-budget"
                  name="budget"
                  errorMessage={error?.budget}
                  showError={
                    !error.budget || error.budget === "" ? false : true
                  }
                />
              </div>
            )}
          {authorData.amcFormFlag && (
            <div className="mb-20">
              <SelectDropdown
                data={typeItems?.map(item => item.type)}
                label={`${staticText?.constructionTypeLabel}`}
                onChange={val => handleDropDownChange(val, "constructionType")}
                value={data?.constructionType}
                id="omni-channel-type"
                name="constructionType"
              />
            </div>
          )}
          {authorData.omniChannelKECFormFlag && (
            <div className="mb-20">
              <SelectDropdown
                label={`${staticText?.purchasePickListLabel}*`}
                data={purchaseTimeItems?.map(item => item.timeSlot)}
                onChange={val => handleDropDownChange(val, "purchasePick")}
                value={data?.purchasePick}
                errorMessage={staticText?.purchasePickError}
                showError={
                  !error.purchasePick || error.purchasePick === ""
                    ? false
                    : true
                }
                onBlur={() => onBlur("purchasePick")}
                id="omni-channel-purchasepick"
                name="purchasepick"
              />
            </div>
          )}
          {authorData.siteRegistrationFormFlag && (
            <div className="mb-20">
              <SelectDropdown
                data={productCategoryItems.map(
                  item => item.productCategoryValues
                )}
                label={`${staticText?.productCategoryLable}*`}
                onChange={val => handleDropDownChange(val, "productCategory")}
                onBlur={() => onBlur("productCategory")}
                value={data?.productCategory}
                id="omni-channel-productCategory"
                name="productCategory"
                errorMessage={error?.productCategory}
                showError={
                  !error.productCategory || error.productCategory === ""
                    ? false
                    : true
                }
              />
            </div>
          )}
          {(authorData.warrantyRegistrationFormFlag ||
            authorData.amcFormFlag) && (
            <>
              {!authorData.amcFormFlag ? (
                <div className="omni-channel-form__upload-text">
                  Upload document [Material Requisition/ Quote/ Invoice]
                </div>
              ) : (
                <div className="omni-channel-form__upload-text">
                  Upload Invoice
                </div>
              )}
              <div className="omni-channel-form__upload-description">
                Supported Files Are: .jpg, .jpeg, .png, .pdf, .gif
              </div>
              <div className="omni-channel-form__upload-description">
                Maximum File Size per image: 5MB
              </div>
              {!authorData.amcFormFlag && (
                <div className="omni-channel-form__mt-40">
                  <SelectDropdown
                    data={typeItems.map(item => item.type)}
                    label={`${staticText?.fileTypeLabel}`}
                    onChange={val => handleDropDownChange(val, "fileType")}
                    onBlur={() => onBlur("fileType")}
                    value={data?.fileType}
                    id="omni-channel-fileType"
                    name="fileType"
                  />
                </div>
              )}
            </>
          )}
          {(authorData.warrantyRegistrationFormFlag ||
            authorData.amcFormFlag) &&
          Object.keys(data).length > 0 ? (
            <div className="omni-channel-form__image-upload-section omni-channel-form__mt-40">
              <ImageUpload
                uploadButtonAnalytics={`{"eventAction":"my account:register non kohler products:product information:upload photos","eventName":"my account:register non kohler products:product information:upload photos","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"upload photos","internalLinkPosition":"register products","internalLinkType":"my account:navigation","internalLinkZoneName":"my account:register non kohler products:product information","internalLinkURL":"n/a","clickInternalLinks":"true"}`}
                data={data}
                staticText={staticText}
                handleData={setData}
                isOmnichannel={true}
                clearImage={clearImage}
                authorData={authorData}
                setUploadImageLoading={setUploadImageLoading}
                setClearImage={setClearImage}
              />
            </div>
          ) : null}
          {authorData.omniChannelKECFormFlag &&
          data.slot === "" &&
          data.appointmentDate === "" ? (
            <>
              <div
                className={`omni-channel-form__visit-title ${
                  !Object.keys(monthlyAvailabilityData).length
                    ? "omni-channel-form__disabled"
                    : ""
                }`}
              >
                Schedule Your Visit*
              </div>
              <div
                className={`omni-channel-form__visit-description ${
                  !Object.keys(monthlyAvailabilityData).length
                    ? "omni-channel-form__disabled"
                    : ""
                }`}
              >
                Choose a date & time. Visit can be scheduled for next 30 days.
              </div>
              <div className="omni-channel-form__image-upload-section omni-channel-form__mt-40">
                <DateTimePicker
                  disabled={!Object.keys(monthlyAvailabilityData).length}
                  onChangeDateTime={(slot, date) =>
                    onChangeDateTime(slot, date)
                  }
                  isEdit={isEdit}
                  kecData={data}
                  setIsEdit={setIsEdit}
                  monthlyAvailability={monthlyAvailabilityData}
                  error={error}
                  setError={setError}
                />
              </div>
            </>
          ) : null}
          {authorData.omniChannelKECFormFlag &&
          data.slot !== "" &&
          data.appointmentDate !== "" ? (
            <>
              <div className="omni-channel-form__visit-title">
                {" "}
                Your Selected Slot
              </div>
              <div className="omni-channel-form__selected-slot-details">
                <div className="omni-channel-form__selected-slot">
                  {`${formatDate(data.appointmentDate)} • ${data?.slot}`}
                </div>
                <button
                  role="link"
                  className="omni-channel-form__change-slot"
                  onClick={() => {
                    setIsEdit(true)
                    changeSlotAnalytics(data)
                  }}
                >
                  Change Slot
                </button>
              </div>
              {isEdit && (
                <div className="omni-channel-form__image-upload-section omni-channel-form__mt-40">
                  <DateTimePicker
                    disabled={!Object.keys(monthlyAvailabilityData).length}
                    onChangeDateTime={(slot, date) =>
                      onChangeDateTime(slot, date)
                    }
                    isEdit={isEdit}
                    kecData={data}
                    setIsEdit={setIsEdit}
                    monthlyAvailability={monthlyAvailabilityData}
                  />
                </div>
              )}
            </>
          ) : null}
          {isQrService && authorData.serviceRequestFormFlag && (
            <div className="mb-20">
              <SelectDropdown
                data={productCategoryItems.map(
                  item => item.productCategoryValues
                )}
                label={`${staticText?.productDetailsLabel}*`}
                onChange={val => handleDropDownChange(val, "productCategory")}
                onBlur={() => onBlur("productCategory")}
                value={data?.productCategory}
                id="omni-channel-productCategory"
                name="productCategory"
                errorMessage={error?.productCategory}
                showError={
                  !error.productCategory || error.productCategory === ""
                    ? false
                    : true
                }
              />
            </div>
          )}
          {isQrService && authorData.serviceRequestFormFlag && (
            <Input
              customClass="customer-support-inputfield"
              id="contact-user-mobile-number"
              type="text"
              value={data?.reportIssue}
              maxLength={255}
              placeholder={`${staticText?.reportIssueLabel}*`}
              label={`${staticText?.reportIssueLabel}*`}
              onChange={handleAlphaNumericFieldChange}
              onInput={handleAlphaNumericFieldChange}
              showError={error?.reportIssue}
              errorMessage={error?.reportIssue}
              onBlur={() => onBlur("reportIssue")}
              name="reportIssue"
            />
          )}
          {isQrService && authorData.serviceRequestFormFlag && (
            <DatePicker
              value={Date.parse(data?.dateOfInvoice)}
              selected={Date.parse(data?.dateOfInvoice)}
              dateFormat="dd/MM/yyyy"
              customInput={
                <Input
                  customClass="customer-support-inputfield"
                  prefix={<img src={calenderIcon?.src} alt="calendar-icon" />}
                  placeholder={`${staticText?.dateOfInvoiceLabel}`}
                  label={`${staticText?.dateOfInvoiceLabel}`}
                  showError={error?.dateOfInvoice}
                  errorMessage={error?.dateOfInvoice}
                />
              }
              id={"contact-installed-installDate"}
              onChange={date => changeDateFormat(date)}
              minDate={new Date("01/01/2001")}
              maxDate={new Date()}
              isClearable={!!data?.dateOfInvoice}
            />
          )}
          {isAllFieldsFilled && (
            <div className="omni-channel-form__recaptcha-div">
              <ReCAPTCHA
                sitekey={recaptchaSiteKey}
                onChange={value => {
                  onChangeHandler(value)
                }}
                onErrored={() => handleError(numberOfReTries + 1)}
                onExpired={() => setRecaptchaVerified(false)}
              />
            </div>
          )}
          <div className="omni-channel-form__consent-checkbox">
            <Checkbox
              type="black"
              value={staticText?.whatAppConent}
              onChange={e => handleConsent(e, "whatsAppConsent")}
              checked={data?.whatsAppConsent}
              textClassName={`omni-channel-form__consent-checkbox-label`}
            />
          </div>

          <div className="omni-channel-form__consent-checkbox">
            <Checkbox
              ttype="black"
              value={staticText?.smsEmailConsent}
              onChange={e => handleConsent(e, "smsAppConsent")}
              checked={data?.smsAppConsent}
              textClassName={`omni-channel-form__consent-checkbox-label`}
            />
          </div>

          <div className="lead-generation__buttonDiv">
            <Button
              type="black"
              role="button"
              label={`${staticText?.submitLabel}`}
              className="lead-generation__button"
              flexible
              onClick={handleSubmit}
              disabled={isSubmitBtnEnabled}
              loading={isLoading}
            />
          </div>
        </div>
        {modalDisplayFlag && (
          <Modal onModalClose={modalCloseHandler} showModal={modalDisplayFlag}>
            <div className="omni-channel-form__success-box">
              <div className="wrapper">
                <div className="omni-channel-form__success-description">
                  {!isQrService && !isKohlerCare
                    ? getSuccessMessageByPageType(authorData)?.map(
                        (msg, index) => {
                          return <p key={"1" + index}>{msg}</p>
                        }
                      )
                    : getSuccessMessageByPageTypeService(authorData)?.map(
                        (msg, index) => {
                          return <p key={"1" + index}>{msg}</p>
                        }
                      )}
                </div>
                <div className="button-holder">
                  <Button
                    type="black"
                    role="button"
                    label={`${
                      authorData.bathroomInspirationFormFlag
                        ? "View Catalogue"
                        : "Close"
                    }`}
                    className="omni-channel-form__success-button"
                    flexible
                    onClick={modalCloseHandler}
                  />
                </div>
              </div>
            </div>
          </Modal>
        )}
        {showErrorModal && (
          <Modal
            hideCloseIcon={true}
            onModalClose={closeErrorModal}
            showModal={showErrorModal}
          >
            <div className="omni-channel-form__error-box">
              <div className="wrapper">
                <div className="omni-channel-form__success-description">
                  <div className="omni-channel-form__error-title">
                    {!kecSlotBooked ? "Something went wrong!" : ""}
                  </div>
                  <div className="omni-channel-form__error-title">
                    {!kecSlotBooked
                      ? `Please try again after some time or call us at 1-800-103-2244.`
                      : errorMessage}
                  </div>
                </div>
                <div className="button-holder">
                  <Button
                    type="black"
                    role="button"
                    label={`Close`}
                    className="omni-channel-form__success-button"
                    flexible
                    onClick={closeErrorModal}
                  />
                </div>
              </div>
            </div>
          </Modal>
        )}
      </div>
    </>
  )
}

export default RecaptchaForm
